import { render } from "./NoCroupier.vue?vue&type=template&id=7231e33c&scoped=true"
const script = {}

import "./NoCroupier.vue?vue&type=style&index=0&id=7231e33c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Benny\\Desktop\\dev\\croup-terminal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7231e33c"]])

export default __exports__